import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'
import brushImg from './img/brush.png'
import separatorImg from './img/separator.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro228">
      <div className="bp1-intro228mobile anima-word-break">
        <div className="bp1-mainbackground">
          <img src={background || backgroundImg} className="background-image" />
        </div>
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-names bp1-intro228-anima-animate-enter3">
              {!!coupleSimplifiedName.groom && (
                <div className="bp1-couplesimplifiednam bp1-intro228-anima-animate-enter1">
                  <span
                    data-id="Label-3282fbca-0e13-4d41-a0c3-f3d7cd4e0f13 bp1-span1"
                    className="bp1-span1"
                  ></span>

                  <span
                    data-id="Label-3282fbca-0e13-4d41-a0c3-f3d7cd4e0f13 bp1-span2"
                    className="bp1-span2 notranslate"
                  >
                    {coupleSimplifiedName.groom}
                  </span>

                  <span
                    data-id="Label-3282fbca-0e13-4d41-a0c3-f3d7cd4e0f13 bp1-span3"
                    className="bp1-span3"
                  ></span>
                </div>
              )}
              <img
                alt="Image/"
                src={separatorImg}
                className="bp1-image1"
                style={!coupleSimplifiedName.groom ? { display: 'none' } : {}}
              />
              <div
                style={
                  !coupleSimplifiedName.groom
                    ? { width: '100%', textAlign: 'center' }
                    : {}
                }
                className="bp1-couplesimplifiednam1 bp1-intro228-anima-animate-enter2"
              >
                <span
                  data-id="Label-579e5e52-2523-4e40-9e1a-a54e7680e377 bp1-span1"
                  className="bp1-span1"
                ></span>
                <span
                  data-id="Label-579e5e52-2523-4e40-9e1a-a54e7680e377 bp1-span2"
                  className="bp1-span2 notranslate"
                >
                  {coupleSimplifiedName.bride}
                </span>
                <span
                  data-id="Label-579e5e52-2523-4e40-9e1a-a54e7680e377 bp1-span3"
                  className="bp1-span3"
                ></span>
              </div>
            </div>
            <div className="bp1-date bp1-intro228-anima-animate-enter">
              <img alt="Image/" src={brushImg} className="bp1-fill1" />
              <div className="bp1-v303osecasar">{text}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro228desktop anima-word-break">
        <div className="bp2-mainbackground">
          <img src={background || backgroundImg} className="background-image" />
        </div>
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-names bp2-intro228-anima-animate-enter3">
              {!!coupleSimplifiedName.groom && (
                <div className="bp2-couplesimplifiednam bp2-intro228-anima-animate-enter1">
                  <span
                    data-id="Label-b6c7cec4-5b3d-4fee-aad4-045463af44c7 bp2-span1"
                    className="bp2-span1"
                  ></span>
                  <span
                    data-id="Label-b6c7cec4-5b3d-4fee-aad4-045463af44c7 bp2-span2"
                    className="bp2-span2 notranslate"
                  >
                    {coupleSimplifiedName.groom}
                  </span>
                  <span
                    data-id="Label-b6c7cec4-5b3d-4fee-aad4-045463af44c7 bp2-span3"
                    className="bp2-span3"
                  ></span>
                </div>
              )}

              <img
                alt="Image/"
                src={separatorImg}
                className="bp2-image1"
                style={!coupleSimplifiedName.groom ? { display: 'none' } : {}}
              />

              <div
                style={
                  !coupleSimplifiedName.groom
                    ? { width: '100%', textAlign: 'center' }
                    : {}
                }
                className="bp2-couplesimplifiednam1 bp2-intro228-anima-animate-enter2"
              >
                <span
                  data-id="Label-37cd23e2-132e-4559-95a3-39b0e7de9189 bp2-span1"
                  className="bp2-span1"
                ></span>
                <span
                  data-id="Label-37cd23e2-132e-4559-95a3-39b0e7de9189 bp2-span2"
                  className="bp2-span2 notranslate"
                >
                  {coupleSimplifiedName.bride}
                </span>
                <span
                  data-id="Label-37cd23e2-132e-4559-95a3-39b0e7de9189 bp2-span3"
                  className="bp2-span3"
                ></span>
              </div>
            </div>
            <div className="bp2-date bp2-intro228-anima-animate-enter">
              <img alt="Image/" src={brushImg} className="bp2-fill1" />
              <div className="bp2-v303osecasar">{text}</div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
